import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=0bce77e6&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=0bce77e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce77e6",
  null
  
)

export default component.exports